// extracted by mini-css-extract-plugin
export default {"section":"DudeSection_section__-MHSO","content":"DudeSection_content__3MXVk","dude":"DudeSection_dude__L3zh5","dude__inner":"DudeSection_dude__inner__YItap"};